module.exports = __webpack_public_path__ + "static/media/07-usa.e0402539.png";